import React from "react";
import { useNavigate } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useSelector } from "react-redux";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import performRequest from "../../../api/request";

const tableHead = [
  "Sr.",
  "Farm Name",
  "Crop Name",
  "Crop cycle name",
  "Type of system",
  "progress",
  "Actions",
];
const tableHeadClient = [
  "Sr.",
  "Crop Name",
  "Crop cycle name",
  "Type of system",
  "progress",
  "Actions",
];
const getProgress = (tasks = []) => {
  let data = tasks?.filter((el) => el.scheduleDone) || [];
  return `${data?.length} / ${tasks?.length}`;
};
const CropUpdateTable = ({
  data = [],
  currentPage,
  itemsPerPage,
  showArchived,
  onActionComplete,
}) => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);

  const goToView = (id) => {
    navigate(`/farm-crop-schedule/view/${id}`);
  };

  const archiveCrop = async (id) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/cropUpdate/updateCropArchiveStatus/${id}`,
        { archieveData: true }
      );
      if (res.status === 200) onActionComplete();
    } catch (err) {
      console.log(err);
    }
  };

  const restoreCrop = async (id) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/cropUpdate/updateCropArchiveStatus/${id}`,
        { archieveData: false }
      );
      if (res.status === 200) onActionComplete();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {store.Role === process.env.REACT_APP_ROLE_CLIENT
              ? tableHeadClient.map((item, index) => (
                  <th key={index}>{item}</th>
                ))
              : tableHead.map((item, index) => <th key={index}>{item}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => {
            // Correctly accessing the last entry's scheduleDate
            // const lastEntryScheduleDate =
            //   item?.timeLines[item.timeLines.length - 1]?.scheduleDate || null;
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                  <td>{item?.farmName || "N/A"}</td>
                )}
                <td>{item?.cropName || "N/A"}</td>
                <td>{item?.cropCycleName || "N/A"}</td>
                <td>{item?.typeOfSystem || "N/A"}</td>
                <td>{getProgress(item?.cropPhoto) || "N/A"}</td>
                <td>
                  <div className="d-flex gap-2">
                    <CustomViewButton onClick={() => goToView(item?.id)} />

                    {!showArchived ? (
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => archiveCrop(item.id)}
                      >
                        Archive
                      </button>
                    ) : (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => restoreCrop(item.id)}
                      >
                        Restore
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CropUpdateTable;
